import { usePermissions } from "@/hooks/usePermissions";
import type { PropsWithChildren } from "react";
import { LoadingSpinner } from "../../ui/spinner";

export const CompanyAdminOnly = ({ children }: PropsWithChildren) => {
  const { isAccountingFirmAdmin, isLoading } = usePermissions();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center p-4">
        <LoadingSpinner />
      </div>
    );
  }

  if (!isAccountingFirmAdmin) {
    return null;
  }

  return <>{children}</>;
};
